import { render } from "./PfDataLinks.vue?vue&type=template&id=37049988"
import script from "./PfDataLinks.vue?vue&type=script&lang=js"
export * from "./PfDataLinks.vue?vue&type=script&lang=js"

import "./PfDataLinks.vue?vue&type=style&index=0&id=37049988&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__